/**
 * AB#1904 (W-1) — UnlockedFeatureCard.
 *
 * Single "what's now unlocked" tile on the post-checkout success page.
 * Icon + title + 1-line description. The success page renders 3-4 of
 * these in a grid based on the target tier (see Dina §4.4 unlock matrix).
 */
import React from 'react';
import s from './UnlockedFeatureCard.module.css';

export interface UnlockedFeatureCardProps {
    icon: string;
    title: string;
    description: string;
}

const UnlockedFeatureCard: React.FC<UnlockedFeatureCardProps> = ({
    icon,
    title,
    description,
}) => (
    <div className={s.card}>
        <div className={s.icon} aria-hidden="true">{icon}</div>
        <div className={s.title}>{title}</div>
        <div className={s.description}>{description}</div>
    </div>
);

export default UnlockedFeatureCard;
